import React from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from './component/Contact';
import Services from './component/Services';
import BlogPanel from './component/BlogPanel';
import '../style/Blog.css';
import '../style/Home.css';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <div className="main">
      <header className="header">
        <div className="brand-block">
          <h1 className="title">Aberrest</h1>
          <h2 className="subtitle">Applied AI for Alts</h2>
        </div>
        <div className="logo-animated"></div>
      </header>

      <div className="blog">
        <div className="blog-header">
          <div className="back-button" onClick={() => navigate('/')}>← Home</div>
        </div>
        <BlogPanel />

        <div className="blog-services">
          <Services />
        </div>

        <Contact />

      </div>
    </div>
  );
};

export default Blog;
